import { ReviewStarHalfSolidIcon, ReviewStarSolidIcon } from '@ikyucom/design-system-icons-react'
import { css, cva } from '~/styled-system/css'
import type { RecipeVariantProps } from '~/styled-system/css'

const container = cva({
  base: {
    position: 'relative',
    height: '[1em]',
    width: '[5em]',
    color: 'gray.400',
    '& > *': {
      position: 'absolute',
      top: '0',
    },
  },
  variants: {
    size: {
      sm: { fontSize: 'base' },
      md: { fontSize: 'xl' },
      lg: { fontSize: '3xl' },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

type RatingStarsProps = { value: number } & RecipeVariantProps<typeof container>

export function RatingStars({ size, value }: RatingStarsProps) {
  return (
    <div className={container({ size })}>
      {Array.from({ length: 5 }, (_, i) => (
        <Star key={`${value}-${i}`} value={value} index={i} />
      ))}
    </div>
  )
}

const activeStar = css({ color: 'review.icon' })

/** index 番目の星を描く */
function Star({ value, index }: { value: number; index: number }) {
  const style = { left: `${index}em` }

  // value - index の値でその星の塗り方が決まる
  if (value - index >= 1) {
    // 残りが1以上の場合は星全体を塗る
    return <ReviewStarSolidIcon className={activeStar} style={style} />
  }
  if (value - index >= 0.5) {
    // 残りが0.5以上の場合は半分だけ塗る
    return (
      <>
        <ReviewStarSolidIcon style={style} />
        <ReviewStarHalfSolidIcon className={activeStar} style={style} />
      </>
    )
  }
  // それ未満なら塗らない
  return <ReviewStarSolidIcon style={style} />
}
